import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import PanelItem from './panelItem';
import { colorGrid } from 's2s-themes';

// NOTE: For current version of StarPhone we are only displaying phone numbers. In future versions we will be adding fax number, emails, and other categories

const PanelListContainer = styled.div`
  background-color: ${colorGrid.gray0};
  display: flex;
  flex: 1;
  flex-direction: column;
  /* font-size: 12px; */
  overflow-x: hidden;
  overflow-y: auto;
`;

const CardPanelContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const PanelHeader = styled.div`
  align-items: center;
  background-color: #f2f2f3;
  color: #33414d;
  display: flex;
  font-size: 14px;
  font-weight: 600;
  justify-content: flex-start;
  line-height: 16px;
  padding-left: 16px;
  height: 24px;
`;

const StyledUl = styled.ul`
  list-style-type: none;
  margin: 0px;
  padding: 0px;
`;

const PanelLi = styled.li`
  
`;

const PanelList = (props) => {

  const renderPanelItems = (panelItems=[], cbItemClicked, cbPhoneNumberValidation) => {
    //console.log("panelItems", panelItems );

    return panelItems.map((item, index) => {
      const itemKeys = Object.keys(item);

      const filteredKeys = itemKeys.filter((key) => {
        return key !== 'type' && key !== 'preferred';
      });

      const itemOnClick = () => { cbItemClicked(item); };

      const prettifiedTitle = item.type && item.type.charAt(0).toUpperCase() + item.type.slice(1);

      return (
        <PanelLi key={index} >
          <PanelItem
            actionTitle={prettifiedTitle}
            actionValue={item[filteredKeys[0]]}
            cbClick={itemOnClick}
            displayButton={typeof item.number !== "undefined" && cbPhoneNumberValidation(item.number)}
          />
        </PanelLi>
      );
    });
  };

  const renderPanelList = (contactType, panelItems=[], cbItemClicked, cbPhoneNumberValidation) => {
    const contactTypeMap = {
      'emails': 'Email',
      'fax_numbers': 'Fax',
      'phone_numbers': 'Phone'
    };

    const otherContactInfo = [];

    Object.keys(panelItems).filter((otherInfo) => {
      return Array.isArray(contactType[otherInfo]) && otherInfo !== 'emails' && otherInfo !== 'fax_numbers' && otherInfo !== 'phone_numbers';
    }).map((otherInfo) => {
      //console.log('OTHER INFO', otherInfo);
      const otherInfoKeys = Object.keys(contactType[otherInfo][0]);

      return contactType[otherInfoKeys].forEach((infoItem) => {
        otherContactInfo.push(infoItem);
      });
    });

    return (
      <CardPanelContainer className="cardPanel">
        <PanelHeader className="panelHeader">
          {contactTypeMap[contactType] !== undefined ? contactTypeMap[contactType] : 'Other'}
        </PanelHeader>
        <StyledUl>{contactType !== 'other' ? renderPanelItems(panelItems[contactType], cbItemClicked, cbPhoneNumberValidation) : renderPanelItems(otherContactInfo, cbItemClicked, cbPhoneNumberValidation)}</StyledUl>
      </CardPanelContainer>
    );
  };

  return (
    <PanelListContainer
      className="panelList"
      onScroll={props.cbOnScroll}
    >
      {renderPanelList('phone_numbers', props.panelItemList, props.cbItemClicked, props.cbPhoneNumberValidation)}
    </PanelListContainer>
  );
};

PanelList.propTypes = {
  cbItemClicked: PropTypes.func,
  cbOnScroll: PropTypes.func,
  cbPhoneNumberValidation: PropTypes.func,
  intl : PropTypes.string,
  panelItemList: PropTypes.object
};

PanelList.defaultProps = {
  cbItemClicked: () => { console.log('cbItemClicked is not defined'); },
  cbOnScroll: () => { console.log(); },
  cbPhoneNumberValidation : () => { console.log('cbPhoneNumberValidation is not defined.' ); },
  panelItemList: {}
};


export default PanelList;
